import { Flex } from 'antd';
import React, { useMemo } from 'react';
import ExpandableContent from '~/components/shared/ExpandableContent/ExpandableContent';

import ConversationListItem from './ConversationListItem';

function ConversationListGrouped({ conversations, selectedConversation, onSelectConversation }) {
  const { aTraiter, enAttente } = useMemo(() => {
    const result = { aTraiter: [], enAttente: [] };
    for (const c of conversations) {
      if (c.section === 'awaiting_response') result.enAttente.push(c);
      else result.aTraiter.push(c);
    }
    return result;
  }, [conversations]);

  return (
    <Flex vertical>
      {aTraiter.length > 0 && (
        <ExpandableContent variant='bar' title={`À traiter (${aTraiter.length})`} withArrow defaultExpanded>
          <Flex vertical>
            {aTraiter.map((conversation) => (
              <ConversationListItem
                key={conversation.id}
                conversation={conversation}
                isSelected={selectedConversation === conversation.id}
                onSelect={onSelectConversation}
              />
            ))}
          </Flex>
        </ExpandableContent>
      )}
      {enAttente.length > 0 && (
        <ExpandableContent variant='bar' title={`Réponse en attente (${enAttente.length})`} withArrow defaultExpanded>
          <Flex vertical>
            {enAttente.map((conversation) => (
              <ConversationListItem
                key={conversation.id}
                conversation={conversation}
                isSelected={selectedConversation === conversation.id}
                onSelect={onSelectConversation}
              />
            ))}
          </Flex>
        </ExpandableContent>
      )}
    </Flex>
  );
}

export default ConversationListGrouped;
